export default __webpack_public_path__ + "static/media/fiddle-fig.a3b30a8a.jpg";